import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "autoplay", "controls", "loop", "muted", "width", "height"]
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src", "height"]

import { BlockMedia, MediaType } from "@/views/blocks/PageBlock.interface";
import Image from "@/views/blocks/shared/section/media/image/Image.vue";

type MediaProps = {
    data: BlockMedia;
    imageClass?: string;
    imageWidth: number;
    imageHeight: number;
    videoClass?: string;
    videoWidth: number;
    videoHeight: number;
    iframeHeight?: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'Media',
  props: {
    data: {},
    imageClass: {},
    imageWidth: {},
    imageHeight: {},
    videoClass: {},
    videoWidth: {},
    videoHeight: {},
    iframeHeight: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (!_ctx.data.mediaType || _ctx.data.mediaType === _unref(MediaType).IMAGE)
    ? (_openBlock(), _createBlock(Image, {
        key: 0,
        src: _ctx.data.src,
        alt: _ctx.data.alt,
        class: _normalizeClass(['w-full h-full object-cover', _ctx.imageClass]),
        width: _ctx.imageWidth,
        height: _ctx.imageHeight
      }, null, 8, ["src", "alt", "class", "width", "height"]))
    : (_ctx.data.mediaType === _unref(MediaType).VIDEO)
      ? (_openBlock(), _createElementBlock("video", {
          key: `${_ctx.data.videoSrc}-${_ctx.data.videoAutoplay}-${_ctx.data.videoControls}-${_ctx.data.videoLoop}`,
          src: _ctx.data.videoSrc,
          autoplay: _ctx.data.videoAutoplay,
          controls: _ctx.data.videoControls,
          loop: _ctx.data.videoLoop,
          muted: _ctx.data.videoAutoplay,
          class: _normalizeClass(['w-full h-full object-cover', _ctx.videoClass]),
          width: _ctx.videoWidth,
          height: _ctx.videoHeight,
          preload: "metadata"
        }, [
          _cache[0] || (_cache[0] = _createTextVNode(" Download the ")),
          _createElementVNode("a", {
            href: _ctx.data.videoSrc,
            class: "underline text-blue-600"
          }, "video file", 8, _hoisted_2),
          _cache[1] || (_cache[1] = _createTextVNode(". "))
        ], 10, _hoisted_1))
      : (_ctx.data.mediaType === _unref(MediaType).IFRAME)
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 2,
            src: _ctx.data.iframeSrc,
            width: "100%",
            height: _ctx.iframeHeight ? _ctx.iframeHeight : '100%',
            allow: "autoplay; fullscreen",
            loading: "lazy"
          }, " Your browser does not support iframes. ", 8, _hoisted_3))
        : _createCommentVNode("", true)
}
}

})